import script from "./workFlow.vue?vue&type=script&lang=ts&setup=true"
export * from "./workFlow.vue?vue&type=script&lang=ts&setup=true"

import "./workFlow.vue?vue&type=style&index=0&id=299090a8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-299090a8"]])

export default __exports__